class ManagePrice {

    priceElements = null;

    constructor() {
        this.init();
    }

    async init() {
        const customer = await creodeAjaxAPI.getData('customer');

        // If the customer is not logged in, don't load the price elements.
        if (typeof customer.id == 'undefined' || !customer.id) {
            return;
        }

        this.loadPriceElements();
        await this.setPriceElementPrices();
        this.calculateTotalForAllCarts();
        this.renderPrices();
        this.bindQuantityChangeEvent();
        this.bindVariantChangeEvent();
        this.bindReInitializeForNewPriceElements();
    }

    loadPriceElements() {
        this.priceElements = jQuery('[data-price]');
    }

    async setPriceElementPrices() {
        let priceElementCount = this.priceElements.length;
        let pricesSet = 0;

        this.priceElements.each(
            async (index) => {
                const priceElement = this.priceElements.eq(index);
                const variantId = String(priceElement.attr('data-variant-id'));

                if (variantId === 'undefined') {
                    priceElementCount--
                    return;
                }

                const price = await creodeShopifyCustomPrices.getPriceRawAmount(variantId);

                if (price === null) {
                    priceElementCount--
                    return;
                }

                priceElement.attr('data-price', price);
                pricesSet++;
            }
        );

        await new Promise(
            (resolve) => {
                const interval = setInterval(
                    () => {
                        if (priceElementCount !== pricesSet) {
                            return;
                        }

                        clearInterval(interval);
                        resolve();
                    },
                    10
                );
            }
        );
    }

    calculateTotalForAllCarts() {
        this.calculateCartTotal('.minicart', '.minicart__total');
        this.calculateCartTotal('.section--cart-page', '.cart__grandtotal', '.hide-desktop *');
    }

    calculateCartTotal(cartWrapperSelector, cartTotalWrapperSelector, exclusionSelector = '') {
        const wrapper = jQuery(cartWrapperSelector).first();
        const priceElements = this.priceElements.filter(
            (index) => {
                const priceElement = this.priceElements.eq(index);
                if (wrapper.find(priceElement).length < 1) {
                    return false;
                }
                if (priceElement.parents(cartTotalWrapperSelector).length) {
                    return false;
                }

                if (exclusionSelector && priceElement.is(exclusionSelector)) {
                    return false;
                }

                return true;
            }
        );

        let total = 0;

        priceElements.each(
            (index) => {
                const priceElement = this.priceElements.eq(index);
                const price = priceElement.attr('data-price') !== '' ? parseInt(priceElement.attr('data-price')) : 0;
                const quantity = priceElement.attr('data-quantity') !== '' ? parseInt(priceElement.attr('data-quantity')) : 1;

                let priceElementTotal = price * quantity;

                if (typeof priceElement.attr('data-discount') !== 'undefined') {
                    priceElementTotal = priceElementTotal - ( priceElementTotal * parseFloat( priceElement.attr( 'data-discount' ) ) );
                }

                total += priceElementTotal
            }
        );

        total = Math.ceil(total);

        this.priceElements.filter(cartTotalWrapperSelector + ' *').attr('data-price', total);
    }

    renderPrices() {
        this.priceElements.each(
            (index) => {
                const priceElement = this.priceElements.eq(index);

                if(priceElement.attr('data-price') === '') {
                    return;
                }

                const price = parseInt(priceElement.attr('data-price'));
                const quantity = typeof priceElement.attr('data-quantity') !== 'undefined' ? parseInt(priceElement.attr('data-quantity')) : 1;

                let total = price * quantity;

                if (typeof priceElement.attr('data-discount') !== 'undefined') {
                    total = total - ( total * parseFloat( priceElement.attr( 'data-discount' ) ) );
                }

                total = Math.ceil(total);

                const formattedPrice = Shopify.formatMoney(total);

                priceElement.text(formattedPrice);
            }
        );
        this.priceElements.prop('hidden', false);
    }

    bindQuantityChangeEvent() {
        jQuery(document).on(
            'change',
            '[name="quantity"]',
            (event) => {
                const input = jQuery(event.target);

                if (input.parents('.product-page-content').length) {
                    this.setProductPageQuantity(input.val());
                }

                this.calculateTotalForAllCarts();
                this.renderPrices();
            }
        );
    }

    bindVariantChangeEvent() {
        BoosterTheme.swatches.events.on(
            'booster:variant:select',
            async () => {
                this.setProductPageVariant();
                await this.setPriceElementPrices();
                this.renderPrices();
            }
        );
    }

    bindReInitializeForNewPriceElements() {
        this.helpers.observePriceElements(
            async () => {
                this.loadPriceElements();
                await this.setPriceElementPrices();
                this.calculateTotalForAllCarts();
                this.renderPrices();
            }
        );
    }

    setProductPageQuantity(quantity) {
        this.priceElements.filter('.product-page-content *:not([data-dont-update-quantity])').attr('data-quantity', quantity);
    }

    setProductPageVariant() {
        const variantId = this.helpers.getProductPageVariantId();

        if (!variantId) {
            return;
        }

        this.priceElements.filter('.product-page-content *').attr('data-variant-id', variantId);
    }

    helpers = {
        /**
         * Gets the currently selected variant ID from the product page
         * @returns {string} The variant id
         */
        getProductPageVariantId() {
            const url = new URL(location.href);
            return url.searchParams.get('variant');
        },

        /**
         * Sets up a mutation observer to watch for elements with [data-price] selector entering the DOM
         * @param {Function} callback - The function to call when new [data-price] elements are detected
         */
        observePriceElements(callback) {
            const observer = new MutationObserver((mutations) => {
                mutations.forEach((mutation) => {
                    if (mutation.type !== 'childList') {
                        return;
                    }

                    mutation.addedNodes.forEach((node) => {
                        // Check if the added node is an element
                        if (node.nodeType !== Node.ELEMENT_NODE) {
                            return;
                        }

                        // Check if the node itself matches [data-price]
                        if (node.matches && node.matches('[data-price]')) {
                            callback(node);
                        }
                        
                        // Check for [data-price] elements within the added node
                        const priceElements = node.querySelectorAll && node.querySelectorAll('[data-price]');
                        if (!priceElements || priceElements.length === 0) {
                            return;
                        }

                        priceElements.forEach((element) => {
                            callback(element);
                        });
                    });
                });
            });

            // Start observing the document body for changes
            observer.observe(document.body, {
                childList: true,
                subtree: true
            });
        }
    }
}

jQuery(document).ready(
    async () => {
        await new Promise(
            (resolve) => {
                const interval = setInterval(
                    () => {
                        if (typeof creodeAjaxAPI == 'undefined') {
                            return;
                        }

                        if (typeof creodeShopifyCustomPrices == 'undefined') {
                            return;
                        }

                        if (typeof Shopify == 'undefined') {
                            return;
                        }

                        if (typeof BoosterTheme == 'undefined') {
                            return;
                        }

                        clearInterval(interval);
                        resolve();
                    },
                    50
                );
            }
        );

        window.managePrice = new ManagePrice();
    }
);
